import * as ActivityService from '../../../utils/services/activities';

/**
 * @desc 获取活动信息
 * @param {*} param0
 * @param {*} params
 */
export function fetchActivityInfo({ commit }, params) {
    return ActivityService.fetchActivityInfo(params)
}

/**
 * @desc 获取活动获奖排行榜
 * @param {*} param0
 * @param {*} activityId
 */
export function fetchRankingList({ commit }, params) {
    return ActivityService.fetchRankingList(params)
}

/**
 * @desc 获取活动页信息
 * @param {*} param0
 * @param {*} activityId
 */
export function fetchImageInfo({ commit }, params) {
    return ActivityService.fetchImageInfo(params)
}

/**
 * @desc MGM活动信息获取
 * @param {*} param0
 * @param {*} activityId
 */
export function refreshActivityImageUrl({ commit }, params) {
    return ActivityService.refreshActivityImageUrl(params)
}



// WEBPACK FOOTER //
// ./src/store/modules/activities/actions.js